function faqToggles() {
  if (document.querySelectorAll(".js-toggle-faqs").length) {
    $('.js-toggle-faqs a').on('click', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      if ( $(this).hasClass('active') ) {
        // Do nothing
      } else {
        $('.js-toggle-faqs a').removeClass('bg-darkBlue text-white active');
        $('.js-toggle-faqs a').addClass('inactive');
        $(this).removeClass('inactive');
        $(this).addClass('bg-darkBlue text-white active');

        $('.js-faq-accordion').removeClass('active block');
        $('.js-faq-accordion').addClass('inactive hidden');
        $(href).addClass('active block');
        $(href).removeClass('inactive hidden');
      }
    })
  }
}

function policyToggles() {
  if (document.querySelectorAll(".js-toggle-policies").length) {
    //$('.js-policy-item').show();

    $('.js-toggle-policies a').on('click', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      href = href.substring(1); console.log(href);
      $('.js-policy-item').hide();


      $('.js-toggle-policies a').removeClass('bg-darkBlue text-white active');
      $('.js-toggle-policies a').addClass('inactive');
      $(this).removeClass('inactive');
      $(this).addClass('bg-darkBlue text-white active');
      
      if ( href == 'all' ) {
        $('.js-policy-item').show();
      } else {
        $("[data-id='" + href + "']").each(function(i) {
          $(this).show(); 
        }); 
      }
      
    });
  }
}


export { faqToggles, policyToggles };